module.exports = __webpack_public_path__ + "img/32.fbced13e.jpg";